// ABOUTME: Renders the asset list and details layout for a selected asset type.
// ABOUTME: Redirects invalid asset types to the default cement mill route.
import {AssetType} from '@hconnect/common/types'
import React, {useLayoutEffect} from 'react'
import {Outlet, useNavigate} from 'react-router'

import {LayoutSettings, SettingsSkeleton} from '../../common/components'

import {AssetsList} from './list'

import {useAssetsQuery} from '@settings/modules/common/hooks'
import {PLANT_ROUTES, getUrl, useUrlParam} from '@settings/modules/routing'

export const PageAssetListPerType: React.FC = () => {
  const {data: assets} = useAssetsQuery()
  const plantCode = useUrlParam('plantCode')
  const assetType = useUrlParam('assetType')
  const navigate = useNavigate()

  const isAssetTypeValid = Object.values(AssetType).includes(assetType as AssetType)

  // effect to redirect to default asset type if the asset type is not valid
  useLayoutEffect(() => {
    if (!isAssetTypeValid) {
      navigate(
        getUrl(PLANT_ROUTES.ASSETS.ASSET_TYPE.path, {plantCode, assetType: AssetType.CementMill})
      )
    }
  }, [isAssetTypeValid, navigate, plantCode, assetType])

  if (!assets || !isAssetTypeValid) {
    return <SettingsSkeleton numberOfDetailsCards={3} />
  }

  return <LayoutSettings list={<AssetsList />} details={<Outlet />} />
}
